import { Button } from 'antd'

import styles from './FormActionsBar.module.css'

interface FormActionsBarProps {
    /** Є незбережені зміни: показуємо напис і «Скасувати», вмикаємо «Зберегти» */
    dirty: boolean
    saving: boolean
    onReset: () => void
    submitLabel?: string
    resetLabel?: string
    /** Напис при змінах; null — без напису (наприклад, для форми пароля) */
    statusText?: string | null
}

/** Панель під формою: завжди на місці, «Зберегти» активна лише при змінах */
export const FormActionsBar = ({
    dirty,
    saving,
    onReset,
    submitLabel = 'Зберегти',
    resetLabel = 'Скасувати',
    statusText = 'Є незбережені зміни',
}: FormActionsBarProps) => (
    <div className={styles['bar']} role="group" aria-label="Дії з формою">
        <span className={styles['status']} aria-live="polite">
            {dirty && statusText ? statusText : ''}
        </span>
        {dirty && (
            <Button onClick={onReset} disabled={saving}>
                {resetLabel}
            </Button>
        )}
        <Button type="primary" htmlType="submit" disabled={!dirty} loading={saving}>
            {submitLabel}
        </Button>
    </div>
)
